import React, {useMemo} from "react";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import Dependencies from "../../../../../../utilities/Dependencies";
import Environment from "../../../../../../services/interfaces/Environment";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';
import {NavLink} from "react-router-dom";

interface MythOfTheSunAndMoonPageProps {
    dependencies: Dependencies,
    env: Environment
}

const MythOfTheSunAndMoonPage     = (props: MythOfTheSunAndMoonPageProps) => {

    const page: PageActions = useMemo(() => new PageActions({
        dependencies: props.dependencies,
        env: props.env,
        title: `Myth of the Sun and Moon - Chase the Fox`,
        description: "The Myth of the Sun and Moon tells the story of how the followers of Phoenicia and Mohiga each viewed the passing of day and night!",
        keywords: ["casarok", "myth", "sun myth", "moon myth", "phoenicia", "mohiga"],
        imgSrc: `chase/world/mythology/sun-moon.png`,
        url: `world/mythology/myth-of-the-sun-and-moon`
    }), [props]);

    /*
    {
	"data": {
		"description": "",
		"imagePath": "https://chasethefox.com/v1/world/images/mythology/",
		"keywords": [
			"casarok",
			"sun myth",
			"moon myth",
			"phoenicia",
			"mohiga"
		],
		"pageLeft": [
			"<h1 class=\"headline\">Myth of the Sun and Moon</h1>",
			"<img class=\"block width-50-percent\" [src]=\"v1/world/images/mythology/sun-moon\" [size]=\"medium\" alt=\"Sun and Moon\" />",
			"<div class=\"world-content myth\">",
			"    <p>",
			"        ",
			"    </p>",
			"    <p>",
			"
			"    </p>",
			"</div>"
		],
		"pageRight": [
			"<div class=\"world-content myth\">",
			"    <p>

			"    </p>
			"    <p>

			"    </p>
			"</div>"
		]
	}
}
     */

    return page.generateMetaContent(
        <>
            <ContentBox header="Myth of the Six Sisters">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="block width-30-percent"
                         src={page.image().getCdnImageSrc(`chase/world/mythology/sun-moon.png`)}
                         alt="Sun and Moon"
                         title="The sun and the moon in the skies above Casarok"/>
                    <div className="world-content myth">
                        <p>
                            Before the <NavLink className="world-link glowing" to="/world/history">Great Cataclysm</NavLink>, there
                            were differing stories about how the sun and moon moved across the sky every day. Two such
                            tales were told by the followers
                            of <NavLink className="world-link glowing" to="/world/pantheon">Phoenicia and Mohiga</NavLink>, the
                            phoenix goddess of the sun and werewolf goddess of the moon. These stories carried on
                            through the ages as mythology to those who no longer believe in the old gods.
                        </p>
                        <p>
                            <strong>From the side of the followers of Phoenicia</strong><br/>
                            The sun goddess rises from her slumber every morning and flies across the daytime skies. No
                            one would defy her daily rite except for the occasional resistance from the storm goddess.
                            The cloud god would aid her flight across the sky everyday and protect her from sight when
                            she deemed fit. Flying across the sky and providing light to the world is a tiresome task,
                            however, even for someone as mighty as the sun goddess. Every evening, she would disappear
                            over the horizon to sleep once again, turning the sky red and orange with her flames as she
                            also does at her rise every morning. The moon goddess would come out for her nightly hunt
                            at this time and stalk her way across the night sky, stealing light from the sun goddess.
                            Nevertheless, the moon goddess would cowardly run and hide behind the horizon as morning
                            came as the sun goddess would always rise again to chase off the moon goddess and begin the
                            day anew. Sometimes the moon goddess could steal no light and would thus prowl in the
                            shadows for her hunt; on the following day, the sun goddess -- not needing to waste energy
                            chasing off the cowardly moon goddess -- is able to bless her followers with great power.
                            Sometimes the moon goddess would show herself in full and shower her followers with power,
                            but this ritual is of no concern to the sun goddess. She is merely run out of the sky every
                            morning all the same...
                        </p>
                        <p>
                            <strong>From the side of the followers of Mohiga</strong><br/>
                            It is said that every time the sky turns red, there is a great battle between the moon
                            goddess and the sun goddess. Every evening the moon goddess is triumphant and slays the sun
                            goddess. However a god cannot truly kill another god. Being a phoenix, the ashes of the sun
                            goddess reform into an egg. The egg of the sun goddess is the greatest trophy one can attain
                            from their hunt. The moon goddess hoists this trophy after her kill and parades it through
                            the night sky. It is a tremendous boon to her followers as she leads them on in the nightly
                            hunt. When the morning comes, the egg hatches and the moon and sun goddess fight anew. Of
                            course, the nightly hunt is tiring even for a goddess, so she disappears behind the horizon
                            to plan her next hunt. The sun goddess then goes about her daily flight. It is a futile
                            ritual, however, as the moon goddess returns fully rested each evening and slays the sun
                            goddess anew. The more proudly the moon goddess carries the egg of the sun goddess, the more
                            powerful she becomes. On days when the egg is fully alight in the night sky, the followers
                            of the moon goddess are granted their greatest blessing. Regardless, when the egg appears at
                            its most ashen, the sun goddess rises stronger than ever on the following morning and her
                            followers are blessed instead.
                        </p>
                        <p>
                            The conflicting stories tell much of the same events. They both explain that the two
                            goddesses are responsible for carrying their heavenly body throughout the sky every day.
                            They both also have explanations for the sunrise and sunset skies. Both myths tell of how
                            the followers of Phoenicia are exceptionally blessed the day after a new moon occurs.
                            Finally, the two tales describe how the followers of Mohiga gain a particular boon during
                            the nights of a full moon.
                        </p>
                    </div>
                </div>
            </ContentBox>
        </>
    );
}

export default MythOfTheSunAndMoonPage;